/** "02:43:18" */
export function formatElapsed(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000))
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const seconds = total % 60
  return [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':')
}

/** Timer rundet til nærmeste kvarter, fx 2,73 → 2,75. Mindst et kvarter. */
export function roundToQuarter(hours: number): number {
  return Math.max(0.25, Math.round(hours * 4) / 4)
}

/** "08:05" i lokal tid. */
export function clockTime(date: Date): string {
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

/** "yyyy-mm-dd" i lokal tid. */
export function isoDay(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

/** Timer mellem to klokkeslæt samme dag ("08:00" → "10:45" = 2,75). Over midnat lægges et døgn til. */
export function hoursBetween(start: string, end: string): number | null {
  const parse = (value: string) => {
    const match = value.match(/^(\d{1,2}):(\d{2})$/)
    return match ? Number(match[1]) * 60 + Number(match[2]) : null
  }
  const from = parse(start)
  const to = parse(end)
  if (from === null || to === null) return null
  const minutes = to >= from ? to - from : to + 24 * 60 - from
  return minutes / 60
}
